"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutDeliveryForSimplifiedCheckoutFlat = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _FindPickupPoints = require("../FindPickupPoints");
var _addresses = require("../addresses");
var _shared = require("../shared");
var _DeliverySummary = require("./DeliverySummary");
var _MainDeliveryMethodSwitch = require("./MainDeliveryMethodSwitch");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const CheckoutDeliveryForSimplifiedCheckoutFlat = props => {
  const {
    homeDeliveryAddressSelectionProps,
    isContinueButtonDisabled,
    isDeliveryOptionsLoaded,
    isFlatSelectionEditMode,
    isMainDeliveryMethodSwitchDisplayed,
    mainDeliveryMethod,
    mainDeliveryMethodSwitchProps,
    onContinueButtonClick,
    pickupPointSelectionProps,
    updateSubscriptionAddress
  } = props;
  const {
    isSubscriptionsPage
  } = (0, _contexts.useCheckoutDeliveryContext)();
  const {
    isAddressFormOpen
  } = (0, _addressFormContext.useAddressForm)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const handleContinueButtonClick = () => {
    if (isSubscriptionsPage) {
      void updateSubscriptionAddress();
    } else if (onContinueButtonClick) {
      onContinueButtonClick();
    }
  };
  if (isDeliveryOptionsLoaded && !isFlatSelectionEditMode) {
    // collapsed summary
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliverySummary.DeliverySummary, {
      ...props
    });
  }

  // full UI for edit mode

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FlatDeliveryWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.FlatLayoutWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        children: formatMessage('delivery')
      }), isDeliveryOptionsLoaded && isMainDeliveryMethodSwitchDisplayed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MainDeliveryMethodSwitch.MainDeliveryMethodSwitch, {
        ...mainDeliveryMethodSwitchProps
      }) : null]
    }), mainDeliveryMethod === _models.AddressItemDeliveryMethod.Home ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_addresses.HomeDeliveryAddressSelection, {
      ...homeDeliveryAddressSelectionProps
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindPickupPoints.PickupPointSelection, {
      ...pickupPointSelectionProps
    }), isAddressFormOpen ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContinueButton, {
      fullWidth: true,
      disabled: Boolean(isContinueButtonDisabled) && !isSubscriptionsPage,
      color: "primary",
      variant: "contained",
      onClick: handleContinueButtonClick,
      ...getTestIdProps(_models.TestId.ContinueButton),
      children: formatMessage(isSubscriptionsPage ? 'confirm' : 'continue')
    })]
  });
};
exports.CheckoutDeliveryForSimplifiedCheckoutFlat = CheckoutDeliveryForSimplifiedCheckoutFlat;